<p-radioButton
  inputId="oneLineForEachReceipt"
  [value]="SC.OneLineForEachReceipt"
  [(ngModel)]="sequenceCategory"
  (click)="onCategoryChanged()"></p-radioButton>
<label for="oneLineForEachReceipt"
       [class]="getLabelClass(sequenceCategory == SC.OneLineForEachReceipt)">One line for each receipt</label>
<p-dropdown
  [options]="oneLineForEachReceiptOptions"
  [(ngModel)]="selectedSequence"
  [disabled]="sequenceCategory == SC.SeparateLineForEachReceipt"
  [class]="getDropdownClass(sequenceCategory == SC.OneLineForEachReceipt)"
  (onChange)="onSequenceChanged($event)">
</p-dropdown>
<div style="margin-bottom:1em;"></div>
<p-radioButton
  inputId="separateLineForEachReceipt"
  [value]="SC.SeparateLineForEachReceipt"
  [(ngModel)]="sequenceCategory"
  (click)="onCategoryChanged()"></p-radioButton>
<label for="separateLineForEachReceipt"
       [class]="getLabelClass(sequenceCategory == SC.SeparateLineForEachReceipt)">A separate line for each receipt allocation</label>
<p-dropdown
  [options]="separateLineForEachReceiptOptions"
  [(ngModel)]="selectedSequence"
  [disabled]="sequenceCategory == SC.OneLineForEachReceipt"
  [class]="getDropdownClass(sequenceCategory == SC.SeparateLineForEachReceipt)"
  (onChange)="onSequenceChanged($event)">
</p-dropdown>
